'use strict'

function plugin (Vue) {
  if (!plugin.installed) {
    /* eslint-disable no-param-reassign */
    const loadScriptList = {}

    Vue.prototype.$loadScript = function (url, script, maxTime = 10000, time = 100, charset = 'utf-8', async = false, defer = false) {
      if (process.browser) {
        if (script && window[script]) {
          return true
        }
        if (!loadScriptList[url]) {
          loadScriptList[url] = 'loading'
          return new Promise( function (resolve, reject ) {
            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = url
            script.charset = charset
            if (async) {
              script.async = true
            }

            if (defer) {
              script.defer = true
            }
            document.body.appendChild(script)

            script.onreadystatechange = function () {
              if (this.readyState === 'complete' || this.readyState === 'loaded') {
                loadScriptList[url] = true
                resolve(true)
              }
            }

            if (script.addEventListener) {
              script.addEventListener('load', () => {
                loadScriptList[url] = true
                resolve(true)
              })
              script.addEventListener('error', () => {
                resolve(false)
              })
              script.addEventListener('abort', () => {
                resolve(false)
              })
            } else if (script.attachEvent) {
              script.attachEvent('onload', () => {
                loadScriptList[url] = true
                resolve(true)
              })
              script.attachEvent('onerror', () => {
                resolve(false)
              })
              script.attachEvent('onabort', () => {
                resolve(false)
              })
            }
          })
        }

        if (loadScriptList[url] === 'loading' && script) {
          return new Promise( function (resolve, reject) {
            const intervalId = setInterval(() => {
              if (window[script]) {
                clearInterval(intervalId)
                resolve(true)
              }
              maxTime -= time
              if (maxTime < 0) {
                clearInterval(intervalId)
                resolve(false)
              }
            }, time)
          })
        }
      }
      return false
    }
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin



// WEBPACK FOOTER //
// ./src/plugins/_common/VueLoadScript.js